import React from 'react';
import { useTranslation } from 'react-i18next';
import PageBody from '@lib/layouts/DashboardLayout/PageBody/PageBody';
import Button from '@lib/components/Button/Button';
import Table from '@lib/components/Table/Table';
import ListEmptyState from '@lib/components/ListEmptyState/ListEmptyState';
import Trans from '@lib/components/Trans/Trans';
import PageHeader from '@lib/layouts/DashboardLayout/PageHeader/PageHeader';
import Search from '@lib/components/Search/Search';
import useSearchParam from '@lib/hooks/useSearchParam';
import getTableActionsMenu from '../../utils/getTableActionsMenu';
import getTableColumns from '../../utils/getTableColumns';
import { UseActionsResult } from '../../utils/useFormChecklistsActions';

interface Props {
  useActionsResult: UseActionsResult;
}

function ChecklistsList(props: Props) {
  const { useActionsResult } = props;
  const { t } = useTranslation();
  const [searchQuery] = useSearchParam();

  const { listQuery, onDestroy, onEdit, onAdd, onOpen } = useActionsResult;

  const tableColumns = getTableColumns({ onOpen, t });
  const tableActionsMenu = getTableActionsMenu({
    t,
    onEdit,
    onDelete: onDestroy,
  });
  const tableEmptyStateActions = [
    <Button
      buttonText={t('create-new-list')}
      key="add"
      leftIcon="add"
      onClick={onAdd}
    />,
  ];
  const tableEmptyState = (
    <ListEmptyState
      actions={tableEmptyStateActions}
      text={<Trans i18nKey="no-form-checklists-text" />}
      title={<Trans i18nKey="no-form-checklists-yet" />}
    />
  );
  return (
    <>
      <PageHeader title={t('forms-checklists-templates')}>
        <Button
          buttonText={t('create-new-list')}
          key="add"
          leftIcon="add"
          onClick={onAdd}
        />
      </PageHeader>
      <PageBody>
        {(!!listQuery.collection?.length || searchQuery) && (
          <Search placeholder={t('checklists-search-placeholder')} />
        )}
        <Table
          actionsMenu={tableActionsMenu}
          columns={tableColumns}
          counterText={t('option-list-template-plural', {
            count: listQuery.totalCount,
          })}
          data={listQuery.collection}
          emptyState={tableEmptyState}
          id="checklists"
          loading={listQuery.loading}
          totalEntries={listQuery.totalCount}
        />
      </PageBody>
    </>
  );
}

export default ChecklistsList;
